import authzUserCan, { PermissionModel, UserActions } from "@granular/authz";
import type { RPCRouter } from "@granular/fabric3-server";
import { inferRouterOutputs } from "@trpc/server";

type RouterOutput = inferRouterOutputs<RPCRouter>;
type ContextWithPermissions = RouterOutput["bizContext"]["getContext"][number];

/**
 * Checks whether or not the user is allowed to perform the given action for the
 * given model and context
 *
 * NOTE: 🔺 This is separated out largely so that we can mock it for tests. The
 * preferred way to use `userCan()` is via the `useOperatingContext` hook.
 *
 * @param action - The user action defined in authz
 * @param model - The model to verify the user permissions for this action
 * @returns Boolean indicating userCan
 */
export const userCanContext = (
  context: ContextWithPermissions | undefined,
  action: UserActions,
  model: PermissionModel,
) => {
  if (!context?.permissions) {
    return false;
  }
  const ctx = {
    permissions: {
      allow: context.permissions.allow,
      deny: context.permissions.deny,
      overrides: context.permissions.overrides ?? undefined,
    },
  };
  return authzUserCan(action, model, ctx);
};
